import Box from '@/Atoms/Box/Box';
import CCButton from '@/Atoms/CCButton/CCButton';
import CCText from '@/Atoms/CCText/CCText';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import React from 'react';
import {Linking, Image, StyleSheet} from 'react-native';

const EmptyView = ({mobileNumber, activeTab}) => {
  const cardData = [
    {
      title: 'Live Classes',
      desc: 'Live IM/GM Classes',
      icon: require('@/Assets/Images/Meetings/Instructor.svg'),
    },
    {
      title: 'Coach',
      desc: 'Personalized training',
      icon: require('@/Assets/Images/Meetings/Coach.svg'),
    },
    {
      title: 'Mentor',
      desc: '1-on-1 Mentor Sessions',
      icon: require('@/Assets/Images/Meetings/Mentor.svg'),
    },
    {
      title: 'Practice',
      desc: 'Learn, compete, & grow',
      icon: require('@/Assets/Images/Meetings/Practice.svg'),
    },
  ];
  return (
    <Box style={styles.container}>
      <Box alignItems="center" flexDirection="row" gap={4} style={styles.sub}>
        <MaterialCommunityIcons
          color={CCColors.Blue}
          fontWeight={500}
          name="information-outline"
          size={20}
        />
        <CCText fontSize={FontSizes[12]} fontWeight={500}>
          Already registered, but can’t see your {activeTab}? Please make sure
          you’re logged in with your &nbsp;
          <CCText fontWeight="bold">registered mobile number</CCText>.
        </CCText>
      </Box>

      <CCText style={styles.heading}>Try School of Chess now</CCText>

      <CCText style={styles.subHeading}>
        Home of the world's best coaches, players and the largest tournaments.
      </CCText>

      <Box style={styles.cardsContainer}>
        {cardData.map((item, index) => (
          <Box key={index} style={styles.card}>
            <Image
              source={require('@/Assets/Images/Meetings/Pattern.svg')}
              style={styles.cardPattern}
            />
            <Image
              resizeMode="contain"
              source={item.icon}
              style={styles.cardIcon}
            />
            <CCText style={styles.cardTitle}>{item.title}</CCText>
            <CCText style={styles.cardDesc}>{item.desc}</CCText>
          </Box>
        ))}
      </Box>

      <Box style={styles.buttonContainer}>
        <CCButton
          style={styles.button}
          onPress={() =>
            Linking.openURL('https://circlechess.com/caissa-school-of-chess/')
          }>
          <CCText style={styles.buttonText}>
            Explore Caissa School of Chess
          </CCText>
        </CCButton>
      </Box>
    </Box>
  );
};

export default EmptyView;

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    padding: 24,
  },

  sub: {
    borderWidth: 0.5,
    borderColor: CCColors.Blue,
    borderRadius: 10,
    marginBottom: 10,
    padding: 10,
  },

  heading: {
    fontSize: 24,
    fontWeight: '500',
    lineHeight: 32,
    textAlign: 'center',
  },

  subHeading: {
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 24,
    textAlign: 'center',
    marginTop: 4,
  },

  cardsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 16,
    marginTop: 32,
  },

  card: {
    width: 215,
    padding: 32,
    borderRadius: 8,
    borderWidth: 1,
    backgroundColor: CCColors.LightYellow,
    borderColor: '#DDD8C8',
  },

  cardPattern: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 90,
    height: 90,
  },

  cardIcon: {
    height: 44,
    width: 44,
    marginBottom: 12,
  },

  cardTitle: {
    fontSize: 16,
    fontWeight: '600',
    lineHeight: 24,
  },

  cardDesc: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 20,
    marginTop: 4,
    whiteSpace: 'nowrap',
  },

  buttonContainer: {
    marginTop: 32,
  },

  button: {
    paddingHorizontal: 32,
    paddingVertical: 12,
    borderRadius: 32,
  },

  buttonText: {
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 24,
    color: CCColors.TextColor.Dark,
  },
});
